<script>
  import { onMount, createEventDispatcher } from "svelte";
  import { fly } from "svelte/transition";
  import Select from "../HTMLElements/Select.svelte";
  import {UserName} from "./store.js";
  import wrappedFetch from "../../wrappedFetch.js";
  export let username;
  let errMsg = "";
  let SecurityQuestion = [];
  let securityQuestionAnswerList = {};
  let isValid = true
  let isLoading = false;
  const dispatch = createEventDispatcher();


    onMount(async function() {
      wrappedFetch("uso/getsecurityquestions")
        .then(res => res.json())
        .then(result => {
          SecurityQuestion = result;
          SecurityQuestion.map(r => (r.label = r.question));
        });
    });

  const validateSecurityQuestions = e => {
    e.preventDefault();
    isValid = true;
    isLoading = true;
    let isAnswerlengthValid;
    const isDistinctQuestions =
      securityQuestionAnswerList.Question1.qRef ==
        securityQuestionAnswerList.Question2.qRef ||
      securityQuestionAnswerList.Question2.qRef ==
        securityQuestionAnswerList.Question3.qRef ||
      securityQuestionAnswerList.Question3.qRef ==
        securityQuestionAnswerList.Question1.qRef
        ? false
        : true;
    const isDistinctAnswers =
      securityQuestionAnswerList.Answer1 ==
        securityQuestionAnswerList.Answer2 ||
      securityQuestionAnswerList.Answer2 ==
        securityQuestionAnswerList.Answer3 ||
      securityQuestionAnswerList.Answer3 == securityQuestionAnswerList.Answer1
        ? false
        : true;
    const isAnswer =
      securityQuestionAnswerList.Answer1 &&
      securityQuestionAnswerList.Answer2 &&
      securityQuestionAnswerList.Answer3;
    if (isAnswer) {
      isAnswerlengthValid =
        securityQuestionAnswerList.Answer1.length < 3 ||
        securityQuestionAnswerList.Answer2.length < 3 ||
        securityQuestionAnswerList.Answer3.length < 3
          ? false
          : true;
    }

    if (!isDistinctQuestions) {
      isValid = false;
      errMsg = "Please select three different questions!";
    } else if (!isAnswer) {
      isValid = false;
      errMsg = "Please provide answers for all questions!";
    } else if (!isDistinctAnswers) {
      isValid = false;
      errMsg = "Please have a different answer for each question!";
    } else if (isAnswer && !isAnswerlengthValid){
      errMsg = "Every answer must be at least three characters long!";
      isValid = false;
    }

    if (!isValid) {
      isLoading = false;
      return;
    }

    securityQuestionAnswerList.UniversalID = $UserName && $UserName != '' ? $UserName : username; ;
    securityQuestionAnswerList.qRef1 = securityQuestionAnswerList.Question1.qRef;
    securityQuestionAnswerList.qRef2 = securityQuestionAnswerList.Question2.qRef;
    securityQuestionAnswerList.qRef3 = securityQuestionAnswerList.Question3.qRef;

    wrappedFetch("user/updatesecurityquestions", {
      method: "post",
      body: JSON.stringify(securityQuestionAnswerList),
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        isLoading = false;
        $UserName && $UserName != '' ? dispatch("pageChange","/register/final") : dispatch("pageChange", "/signin");
      });
   
  };
</script>

<form action="" class="box">
  <div class=" field">
    <a href="{$UserName && $UserName != '' ? '/register/accountconfirmation' : '/account/passwordchangesuccess'}">
      <span class="fas fa-arrow-left" />
      Back
    </a>
  </div>
  <hr />
  <h1 class="title is-4">Security Questions</h1>
  <p class="subtitle is-6">
    These questions and answers will be used if you ever lose access to your
    account.
  </p>
 

  <div class="field">
    <label for="" class="label">Security Question 1</label>

    <Select
      items={SecurityQuestion}
      bind:selected={securityQuestionAnswerList.Question1}
      placeholder="Select first question" />

    <div class="control" style="margin-top: 10px;">
      <input
        type="text"
        placeholder=""
        bind:value={securityQuestionAnswerList.Answer1}
        class="input"
        required="" />

    </div>
  </div>
  <div class="field">
    <label for="" class="label">Security Question 2</label>

    <Select
      items={SecurityQuestion}
      bind:selected={securityQuestionAnswerList.Question2}
      placeholder="Select second question" />

    <div class="control" style="margin-top: 10px;">
      <input
        type="text"
        placeholder=""
        class="input"
        bind:value={securityQuestionAnswerList.Answer2}
        required="" />

    </div>
  </div>

  <div class="field">
    <label for="" class="label">Security Question 3</label>

    <Select
      items={SecurityQuestion}
      bind:selected={securityQuestionAnswerList.Question3}
      placeholder="Select third question" />

    <div class="control" style="margin-top: 10px;">
      <input
        type="text"
        placeholder=""
        class="input"
        bind:value={securityQuestionAnswerList.Answer3}
        required="" />

    </div>
  </div>
  <hr />
   {#if !isValid}
    <p class="help is-danger" style="margin-bottom:0px">{errMsg}</p>
  {/if}
  <div style="text-align: right;">
    <button class="button is-purple {isLoading ? 'is-loading' : ''}" on:click={validateSecurityQuestions}>
      <span class="material-icons" style="padding-right: 5px;">save</span>
      Save
    </button>
  </div>
</form>
